export const table = (header: string, body: string) =>
  `<div class="table-container">
    <table>
      <thead>${header}</thead>
      ${body !== '' ? `<tbody>${body}</tbody>` : ''}
    </table>
  </div>`
